import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Box as MuiBox } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.default
    }
}))

const Box = ({ style, children }) => {
    const classes = useStyles()
    return (
        <MuiBox boxShadow={4} className={classes.root} style={style}>
            {children}
        </MuiBox>
    )
}

Box.propTypes = {
    props: PropTypes.object,
    style: PropTypes.object
}

export default Box
